function IsPC() {
  let userAgentInfo = navigator.userAgent
  let Agents = new Array('Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod')
  let flag = true
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  return flag
}

if (!IsPC()) {
  (function () {
    function w(t) {
      t = t || 3.75
      var e = document.documentElement
      var n = 1
      var a = 0
      a = e.clientWidth ? e.clientWidth : document.body.clientWidth
      n = window.devicePixelRatio ? window.devicePixelRatio : 2
      var i = document.documentElement.clientHeight
      var s = (i < a ? i : a) / t + 'px'
      e.setAttribute('data-dpr', n)
      e.style.fontSize = s
    }

    var t
    w(3.75)
    window.addEventListener('resize', function () {
      clearTimeout(t)
      t = setTimeout(w(3.75), 300)
    }, false)
  })()
}else {
  (function () {
     const recalc = () => {
      let designSize = 375
      let minWidth = 375 
      let html = document.documentElement
      let  w =html.clientWidth < minWidth ? minWidth : html.clientWidth > designSize ? designSize : html.clientWidth
      let rem = ( w / designSize) * 100 
      html.style.fontSize = rem +'px'
    }
    recalc()
    window.addEventListener('resize' , recalc)
  })()
}
